export type SegmentedTab<T = string> = {
  id: T
  label: string
  badgeValue?: number
}

export enum SegmentedControlSize {
  medium = 'medium',
  small = 'small',
}

export type SegmentedControlProps<T = string> = {
  tabs: SegmentedTab<T>[]
  activeTab: T
  onTabChange?: (id: T) => void
  className?: string
  size?: SegmentedControlSize
}
